import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import * as api from 'core/api';
import * as utils from 'core/utils';
import * as flights from 'core/flights';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class FlightVariantsComponent extends Vue {
    @Prop()
    selectedFlight: flights.FlightModel;

    @Prop()
    flightsToFilter: flights.FlightFilterModel[];

    @Prop()
    flightsToView: { [uniqueId: string]: flights.FlightModel };

    @Prop()
    searchParams: flights.FlightSearchParams;

    @Prop()
    searchId: string;

    @Prop()
    passengerCount: number;

    @Prop()
    gaParams: any;

    resultsCount: number = 0;

    resultsPageSize: number = 20;
    resultsVisible: number = this.resultsPageSize;

    mounted() {
        this.resultsCount = this.flightsToFilter.filter((f) => {
            return f.uniqueId === this.selectedFlight.uniqueId || f.parentId === this.selectedFlight.uniqueId;
        }).length;
        (<any>this).$ga.sendPageview('/flights/search/results/group/details', 'Flights / Search / Results / Group / Details', this.gaParams);
    }

    get pagedFlights(): flights.FlightFilterModel[] {
        return this.flightsToFilter.filter((f) => {
            return f.uniqueId === this.selectedFlight.uniqueId || f.parentId === this.selectedFlight.uniqueId;
        }).slice(0, this.resultsVisible);
    }

    bookingUrl(flight: flights.FlightFilterModel) {
        if (this.flightsToView
            && this.flightsToView[flight.uniqueId]?.externalPartner
            && this.searchId
            && flight.uniqueId) {
            return {
                path: '/partner',
                query: {
                    sid: this.searchId,
                    fid: flight.uniqueId,
                    pn: this.flightsToView[flight.uniqueId].externalPartner.name
                }
            };
        } else {
            return new flights.FlightNavigationService()
                .getBookingUrl(this.searchParams, this.searchId, flight.uniqueId);
        }
    }

    getBookingClassLabel(bookingClass: string): string {
        return i18next.t('label_flight_class_' + bookingClass.toLowerCase());
    }

    getBaggageLabel(flightBaggage: api.FlightBaggage, isCabin: boolean): string {
        return utils.Baggage.getLabel(flightBaggage, isCabin);
    }

    getDestinationTooltip(d: api.Destination): string {
        const result = d.localizedName + '<br/>' +
            '<i class="el-icon-location"></i> ' + d.city.localizedName + ', ' +
            d.country.localizedName;

        return result;
    }

    getMoreLabel(): string {
        const b = i18next.t('numerous_flights', { count: this.resultsPageSize });
        return i18next.t('label_show_more_withvalue', <any>{ i: b });
    }

    getSegmentLabel(leg: flights.LegModel, segment: flights.SegmentModel, segmentIndex: number): string {
        if (segment.arrivalDestination.iataCode === leg.segments[segmentIndex + 1].departureDestination.iataCode) {
            return segment.arrivalDestination.iataCode;
        } else {
            return segment.arrivalDestination.city.iataCode;
        }
    }

    hasBaggage(leg: flights.LegModel): boolean {
        return leg.baggage && (leg.baggage.pieceWeight > 0 || leg.baggage.pieces > 0);
    }

    hasBaggageCabin(leg: flights.LegModel): boolean {
        return leg.baggageCabin && (leg.baggageCabin.pieceWeight > 0 || leg.baggageCabin.pieces > 0);
    }

    onFlightDetails(flight: flights.FlightModel) {
        this.$emit('details', flight);
    }
}
